import { VipUnit } from '../types';

export const VIP_DURATION_MAX: Record<VipUnit, number> = {
  month: 120,
  day: 3650,
  lifetime: 1,
};

/** 终身套餐的时长数字恒为 1，由服务端统一归一。 */
export const LIFETIME_VIP_DURATION = 1;

export interface PackageDurationFields {
  vipDuration?: number | null;
  vipUnit?: string | null;
  vipMonth?: number | null;
}

export function normalizeVipUnit(unit?: string | null): VipUnit {
  if (unit === 'day' || unit === 'lifetime') {
    return unit;
  }
  return 'month';
}

export function resolvePackageDuration(pkg: PackageDurationFields): {
  duration?: number;
  unit: VipUnit;
} {
  if (pkg.vipUnit === 'lifetime') {
    return { duration: LIFETIME_VIP_DURATION, unit: 'lifetime' };
  }
  if (pkg.vipDuration != null && pkg.vipDuration > 0) {
    return {
      duration: pkg.vipDuration,
      unit: normalizeVipUnit(pkg.vipUnit),
    };
  }
  if (pkg.vipMonth != null && pkg.vipMonth > 0) {
    return { duration: pkg.vipMonth, unit: 'month' };
  }
  return { unit: 'month' };
}

export function formatPackageDuration(pkg: PackageDurationFields): string {
  const { duration, unit } = resolvePackageDuration(pkg);
  if (unit === 'lifetime') {
    return '终身';
  }
  if (!duration) {
    return '-';
  }
  return unit === 'day' ? `${duration}天` : `${duration}个月`;
}
